import { RemoteFileWithRangeCache } from '@jbrowse/core/util/io';
export class GoogleDriveFile extends RemoteFileWithRangeCache {
    constructor(source, opts) {
        super(source, opts);
        this.statsPromise = this.fetch(source, {
            metadataOnly: true,
        }).then((response) => response.json());
    }
    async fetch(input, opts) {
        return super.fetch(input, opts);
    }
    async stat() {
        return this.statsPromise;
    }
}
